import { PlaintiffModal } from '../index';
import DeleteConfirmationModal from '../ui-control/DeleteConfirmationModal';
import EditIcon from '../../assets/icons/EditIcon.svg?react';
import AddIcon from '../../assets/icons/AddIcon.svg?react';
import { useAddCaseFormContext } from '../../contexts/AddCaseFormContext';
import useCasePlaintiff from '../../hooks/useCasePlaintiff';
import { TOUR_TARGETS } from '../../constants/tourTargets';
import XButton from './XButton';
import { plaintiffItemClasses, deleteBtnTiffClasses, partyCardFrameClasses } from './listItemClasses';

const columnClasses = 'col-span-12 md:col-span-6';

const headerClasses = `bg-surface-alt flex items-center justify-between
  px-4 py-2 rounded-t-md`;

const addButtonClasses = `inline-flex items-center gap-1
  text-sm font-semibold bg-transparent border-0
  px-3.5 py-2 text-primary rounded
  hover:bg-surface-alt/60`;

const itemClasses = `${plaintiffItemClasses} ${partyCardFrameClasses}`;

const itemTopRowClasses = 'flex justify-between';

const itemActionsClasses = 'flex absolute right-2.5';

const itemActionButtonClasses = deleteBtnTiffClasses;

const editIconClasses = 'h-4 w-4';

const itemMetaRowClasses = 'my-2.5 text-body text-sm';

const itemMetaRowLastClasses = 'text-body text-sm';

const CasePlaintiff = () => {
  const { formik } = useAddCaseFormContext();
  const {
    addNewPlainTiff,
    updatePlainTiff,
    requestDeletePlainTiff,
    confirmDeletePlainTiff,
    cancelDeletePlainTiff,
    pendingDeletePlaintiff,
    isConfirmingDelete,
    showModal,
    selectedIndex,
    openModal,
    closeModal,
  } = useCasePlaintiff();

  return (
    <>
      <PlaintiffModal
        show={showModal}
        onClose={closeModal}
        formik={formik}
        selectedTiffIndex={selectedIndex}
        updatePlainTiff={updatePlainTiff}
        onSave={closeModal}
        addNewPlainTiff={addNewPlainTiff}
      />
      <DeleteConfirmationModal
        isOpen={isConfirmingDelete}
        type="plaintiff"
        name={pendingDeletePlaintiff?.personalInfo?.clientName}
        onConfirm={confirmDeletePlainTiff}
        onCancel={cancelDeletePlainTiff}
      />

      <div className={columnClasses} data-tour={TOUR_TARGETS.CASE_PLAINTIFFS}>
        <div className={headerClasses}>
          <strong>Plaintiffs</strong>
          <button
            type="button"
            className={addButtonClasses}
            onClick={() => openModal(formik.values.clients.length)}
          >
            <AddIcon className="text-primary" /> Add Plaintiff
          </button>
        </div>

        {formik.values.clients
          ?.filter((client) => client?.personalInfo?.clientName)
          ?.map((client, index) => (
            <div key={client.clientId || index} className={itemClasses}>
              <div className={itemTopRowClasses}>
                <div>
                  <strong>{client?.personalInfo?.clientName}</strong>
                </div>

                <div className={itemActionsClasses}>
                  <XButton
                    variant="close"
                    className={`${itemActionButtonClasses} mr-6`}
                    onClick={() => openModal(index)}
                    aria-label="Edit plaintiff"
                  >
                    <EditIcon className={editIconClasses} />
                  </XButton>
                  <XButton
                    variant="close"
                    className={`${itemActionButtonClasses} mr-2`}
                    onClick={() => requestDeletePlainTiff(index)}
                    aria-label="Delete plaintiff"
                  >
                    <i className="fas fa-trash-alt" />
                  </XButton>
                </div>
              </div>
              <div className={itemMetaRowClasses}>{client?.personalInfo?.phoneNumber}</div>
              <div className={itemMetaRowClasses}>{client?.personalInfo?.email}</div>
              <div className={itemMetaRowClasses}>
                Insurance: <span className="font-medium">{client?.insurance?.insuranceName}</span>
              </div>
              <div className={itemMetaRowClasses}>{client?.insurance?.adjuster?.name}</div>
              <div className={itemMetaRowClasses}>{client?.insurance?.adjuster?.phoneNumber}</div>
              <div className={itemMetaRowLastClasses}>{client?.insurance?.adjuster?.email}</div>
            </div>
          ))}
      </div>
    </>
  );
};

export default CasePlaintiff;
